/*
 * Copyright (c) 2024. Nedaware SL
 */

import {BasicEntity, BasicProperty} from "../../../basic-entity-back/annotations";
import {PropertyType} from "../../../basic-entity-back/property-type/property-type";
import {Resource} from "../../../api/resource";
import {PropertyMap, ReadWrite} from "../../../basic-entity-back/basic-entity-interface/mapping-external";
import {Uri} from "../../../api/uri";
import {NestedBehavior} from "../../../basic-entity-back/property-type/nested-model-type";
import {ArchivoMandatoSepa} from "../../archivos/archivo-mandato-sepa.model";
import {Cliente} from "../../personas/cliente.model";
import {CuentaBancariaCliente} from "../cuentas-bancarias/cuenta-bancaria-cliente.model";

@BasicEntity({
    name: 'Mandato',
    endpoint: 'mandatos',
    isPaginated: true,
    paginationSizes: [20, 30, 50],
    modelNameProperty: 'lectura',
    type: 'Mandato'
})
export class Mandato extends Resource {
    @BasicProperty({
        isId: true,
        name: 'ID',
        type: PropertyType.Integer()
    })
    private _id: number;

    @BasicProperty({
        name: 'Referencia',
        type: PropertyType.String(),
        readWrite: ReadWrite.ReadOnly,
        nullable: true,
        order: 1
    })
    private _referencia: string;

    @BasicProperty({
        name: 'Pago recurrente',
        type: PropertyType.Boolean(),
        order: 3
    })
    private _pagoRecurrente = true;

    public static readonly MAP_CLIENTE: PropertyMap = {
        name: 'Cliente',
        type: PropertyType.FutureUri('cliente.model.ts')
    }
    @BasicProperty(Mandato.MAP_CLIENTE)
    private _cliente;

    @BasicProperty({
        name: 'Cuenta bancaria',
        type: PropertyType.Uri(CuentaBancariaCliente),
        order: 2
    })
    private _cuentaBancariaCliente: Uri;

    @BasicProperty({
        name: 'Archivo firmado',
        type: PropertyType.NestedModel(ArchivoMandatoSepa, 'mandato', NestedBehavior.SendIriOnly),
        nullable: true,
        order: 4
    })
    private _archivoFirmado: ArchivoMandatoSepa;

    get id(): number {
        return this._id;
    }

    set id(value: number) {
        this._id = value;
    }

    get referencia(): string {
        return this._referencia;
    }

    set referencia(value: string) {
        this._referencia = value;
    }

    get pagoRecurrente(): boolean {
        return this._pagoRecurrente;
    }

    set pagoRecurrente(value: boolean) {
        this._pagoRecurrente = value;
    }

    get cliente() {
        return this._cliente;
    }

    set cliente(value) {
        this._cliente = value;
    }

    get cuentaBancariaCliente(): Uri {
        return this._cuentaBancariaCliente;
    }

    set cuentaBancariaCliente(value: Uri) {
        this._cuentaBancariaCliente = value;
    }

    get archivoFirmado(): ArchivoMandatoSepa {
        return this._archivoFirmado;
    }

    set archivoFirmado(value: ArchivoMandatoSepa) {
        this._archivoFirmado = value;
    }
}

ArchivoMandatoSepa.MANDATO_MAP.type = PropertyType.Uri(Mandato);
